import { MockService } from '../mockService';
import { staticImplements } from '@/decorators/staticImplements';
import { InstallerRepositoryInterface } from '@/api/interfaces/installer/installerRepository';
import { Installer } from '@/api/interfaces/installer/installer';

@staticImplements<InstallerRepositoryInterface>()
export class InstallerRepository {
    static getInstallers(): Promise<Installer[]> {
        const mockService = new MockService<Installer[]>();
        const mockInstallers: Installer[] = [
            {
                id: '11112222-3333-4444-5555-666677778881',
                firstName: 'Max',
                lastName: 'Müller',
                email: 'max.mueller@elektro-mueller.de',
                companies: [
                    {
                        id: 'aaaabbbb-cccc-dddd-eeee-ffff11112222',
                        companyName: 'Elektro Müller GmbH',
                        phoneNumbers: ['+49 89 12345678'],
                        street: 'Marienplatz',
                        houseNumber: '1',
                        zipCode: '80331',
                        city: 'München',
                        email: 'info@elektro-mueller.de',
                    },
                ],
            },
            {
                id: '11112222-3333-4444-5555-666677778882',
                firstName: 'Anna',
                lastName: 'Schmidt',
                email: 'a.schmidt@energietechnik.de',
                companies: [
                    {
                        id: 'aaaabbbb-cccc-dddd-eeee-ffff11113333',
                        companyName: 'Schmidt Energietechnik GmbH',
                        phoneNumbers: ['+49 30 98765432'],
                        street: 'Unter den Linden',
                        houseNumber: '42',
                        zipCode: '10115',
                        city: 'Berlin',
                        email: 'info@energietechnik.de',
                    },
                    {
                        id: 'aaaabbbb-cccc-dddd-eeee-ffff11114444',
                        companyName: 'Solartechnik Nord GmbH & Co. KG',
                        phoneNumbers: ['+49 40 55667788'],
                        street: 'Hafenstraße',
                        houseNumber: '88',
                        zipCode: '22767',
                        city: 'Hamburg',
                        email: 'info@solartechnik.de',
                    },
                ],
            },
        ];
        return mockService.runServiceWithSuccess(mockInstallers, 5);
    }
}
